<template>
  <div style="border: 1px solid #ccc;">
    <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
        :mode="mode"
    />
    <Editor
        style="height: 50vh; overflow-y: hidden;"
        v-model="html"
        :defaultConfig="editorConfig"
        :mode="mode"
        @onCreated="onCreated"
        @onChange="onChange"
    />
  </div>
</template>
<script>
import '@wangeditor/editor/dist/css/style.css'
import Vue from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import axios from 'axios';
export default Vue.extend({
  components: { Editor, Toolbar },
  data() {
    return {
      editor: null,
      html: '',
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入内容...',
        zIndex: 10000, // 设置 z-index 的值
      },
      mode: 'default', // or 'simple'
    }
  },
  methods: {
    onChange(editor){
      this.$emit('contentChange', editor);
    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      let uploadImage = this.editor.getMenuConfig('uploadImage');
      uploadImage.server='/api/upload';
      uploadImage.customUpload= async (file, insertFn)=> {
        // file 即选中的文件
        const fd = new FormData()
        fd.append('file', file)
        let url = process.env["VUE_APP_BASE_API2"]+'/system/image/upload';
        console.log(url )
        let headers ={};
        headers['Content-Type'] = 'multipart/form-data';
        const loading = this.$loading({
          lock: true,
          text: 'div',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let res = await axios.post(url, fd,{headers})
        console.log(res);
        insertFn(res.data.data.originUrl, file.name, '')
        loading.close();
      }
      let uploadVideo = this.editor.getMenuConfig('uploadVideo');
      uploadVideo.customUpload=async (file, insertFn)=> {
        // file 即选中的文件
        const fd = new FormData()
        fd.append('file', file)
        let url = process.env["VUE_APP_BASE_API2"]+'/system/image/upload';
        console.log(url )
        let headers ={};
        headers['Content-Type'] = 'multipart/form-data';
        const loading = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let res = await axios.post(url, fd,{headers})
        loading.close();
        console.log(res);
        insertFn(res.data.data.originUrl, file.thumbUrl, '')
      }
      this.$emit('onCreated', editor);
    },
    getInstance(){
      return  this.editor;
    }
  },
  mounted() {
    // 模拟 ajax 请求，异步渲染编辑器
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
})
</script>
<style scoped lang="scss">
.w-e-full-screen-container{
  z-index: 999;
}
</style>